export const decodeShopifyId = (id: string) => {
  const parsedId = id?.startsWith('gid:') ? id : atob(id);
  const extractedId = parsedId.replace(/gid:\/\/shopify\/.*\//, '');

  return parseInt(extractedId);
};
